import { CHART_COLORS } from "@/components/analytics/ChartCanvas";
import { KpiTable } from "../dashboard/KpiTable";
import { KpiComparisonSection } from "./clients-referrers/components/KpiComparisonSection";
import { useClientsReferrersAnalytics } from "./clients-referrers/hooks/useClientsReferrersAnalytics";
import { ServicesLoadingState } from "./services/components/ServicesLoadingState";

interface ClientsReferrersTabProps {
  from: string;
  to: string;
  basis: "accrual" | "cash";
}

// One sortable table per role instead of navigating one party page at a time.
// Each row still links through to the party detail for the real drill-down.
export function ClientsReferrersTab({ from, to, basis }: ClientsReferrersTabProps) {
  const { clients, referrers, loading } = useClientsReferrersAnalytics({ from, to, basis });

  if (loading) return <ServicesLoadingState />;

  return (
    <div className="space-y-6">
      <KpiComparisonSection
        title="Comparaison - valeur par client"
        description="Total facturé (factures émises), sur la période sélectionnée."
        label="Comparaison valeur par client"
        rows={clients}
        color={CHART_COLORS.primary}
      />
      <KpiTable title="Clients" rows={clients} linkTo={(id) => `/parties/${id}`} />

      <KpiComparisonSection
        title="Comparaison - valeur par référent"
        description="Factures référées + commissions apportées, sur la période sélectionnée."
        label="Comparaison valeur par référent"
        rows={referrers}
        color={CHART_COLORS.success}
      />
      <KpiTable title="Référents" rows={referrers} linkTo={(id) => `/parties/${id}`} />
    </div>
  );
}
